import { useGetProfileParticipantTaskQuery } from 'store/api/pkd/endpoints/participantTask';

const useParticipantTask = ({ participantTaskId, personAccountProfileId }) => {
  const {
    form,
    attributes,
    formid,
    isTaskDetailsLoading,
    taskEntry,
    taskEntryId,
    participantTask,
    participantTaskTitle,
    refetch: refetchProfileParticipantTask,
  } = useGetProfileParticipantTaskQuery(
    { personAccountProfileId, participantTaskId },
    {
      skip             : !personAccountProfileId || !participantTaskId,
      selectFromResult : ({ data, isFetching, isLoading }) => ({
        form                 : data?.form,
        formid               : data?.formId,
        attributes           : data?.attributes,
        isTaskDetailsLoading : isFetching || isLoading,
        taskEntryId          : data?.taskEntryId,
        taskEntry            : data?.taskEntry,
        participantTask      : data?.task,
        participantTaskTitle : data?.taskTitle,
      }),
    }
  );

  return {
    form,
    isTaskDetailsLoading,
    attributes,
    formid,
    taskEntry,
    taskEntryId,
    participantTask,
    participantTaskTitle,
    refetchProfileParticipantTask,
  };
};

export default useParticipantTask;
